import type {Icon} from '@primer/octicons-react'
import {PersonIcon, RepoPushIcon, StarIcon, TypographyIcon} from '@primer/octicons-react'

export interface OrderOptions {
  label: string
  defaultDirection: 'asc' | 'desc'
  icon: Icon
}

const ASCENDING_SUFFIX = '-asc'

export const defaultSortingOptions: Record<string, OrderOptions> = {
  updated: {label: 'Last pushed', defaultDirection: 'desc', icon: RepoPushIcon},
  name: {label: 'Name', defaultDirection: 'asc', icon: TypographyIcon},
  stars: {label: 'Stars', defaultDirection: 'desc', icon: StarIcon},
}

export const sortingOptionsWithRelevance: Record<string, OrderOptions> = {
  relevance: {label: 'Relevance', defaultDirection: 'desc', icon: PersonIcon},
  ...defaultSortingOptions,
}

export function getSortingOptionLabel(sortingKey: string, sortingOptions: Record<string, OrderOptions>) {
  return sortingOptions[sortingKey]?.label || sortingKey
}

export function getSortingKeyAndDirection(sorting: string, defaultSortingKey: string) {
  const selectedKey = sorting || defaultSortingKey
  return splitOrderDirection(selectedKey)
}

function splitOrderDirection(value: string): [string, string] {
  if (value.endsWith(ASCENDING_SUFFIX)) {
    return [value.substring(0, value.length - ASCENDING_SUFFIX.length), 'asc']
  }

  return [value, '']
}
